<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="one-row">
   
    <div class="subscription-content">
      <div class="regiter-title-box">
        <span class="reg-sub-title"> {{fixDisplayLabel('subscription_pages_steps_text')}}</span>
        <span class="reg-main-title" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''">{{$t('landing_page_title')}}</span>
      </div>
        <div class="payment-methods" :class="{ 'loader-container': !braintreeFullyLoaded }">
          
          <AppLoader
            v-if="!braintreeFullyLoaded"
            :is-loading="!braintreeFullyLoaded"
          />
          <BadgeNotification :key="hasUserAppliedCoupon" :label="getCouponLabel" v-if="((braintreeFullyLoaded && !isChangePlan) && hasUserAppliedCoupon)" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''"/>
          <DiscountCouponBanner v-if="!hasUserAppliedCoupon && userUsedCoupon && braintreeFullyLoaded && (!hideCouponBanner || hasDiscountDetails)" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''" @closeDiscountCouponBanner="closeDiscountCouponBanner()" :promo-label="getCouponLabel"/>
          <div v-if="braintreeFullyLoaded && !userUsedCoupon && !hasUserAppliedCoupon" class="coupon-code-box">
            <span class="reg-sub-heading" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''">{{ $t('promo_add_coupon_label') }}</span>
            <div class="coupon-code-container">
            <TextInputField 
              :modelValue="coupon"
              :is-coupon-field="true"
              @update:modelValue="coupon = $event"
              class="set-margin-bottom"
              :is-disabled="disablePromoBox"
              :field-type="'text'"
              name="coupon"
              :placeholder="'coupon'"
              :is-required-value="true"
              :has-error="couponHasError"
              :hide-icon="true"
              :error-message="couponErrorMessage"
            />
            <SubmitButton class="coupon-btn" :label="$t('promo_validate_button')" :isLoading="cc_button_loading" @click="checkCoupon" :disable-button-animation="true"/>

            </div>
          </div>
          <div class="payment-methods-options" v-show="braintreeFullyLoaded">
            <PricingCard @togglePricingModal="togglePricingModal"/>
            <!-- <p v-show="isApplePay"></p> -->
            <!-- Google Pay button -->
            <GooglePay
              v-show="!isApplePay"
              :currentSelectedPlan="currentSelectedPlan"
              :sendNonce="sendNonce"
              :clientToken="clientToken"
            />
            <div class="paypal-wrap" id="paypalWrapper">
              <div id="paypalButton" class=""></div>
              <!-- <div class="paypal-button paypal">
                    <div class="image"
                    ><img
                        class="paypal-image"
                        src="../assets/images/pay_pal_full_color_horizontal.svg"
                        alt="PayPall"
                    /></div>
              </div> -->
            </div>
          <div class="divider">
            <span></span>
            <p>{{$t('card_details_page_or_option_label')}}</p>
            <span></span>
          </div>

          <label class="label"  :class="$i18n.locale === 'ar' ? 'label-right' : ''">{{ $t('card_details_page_title') }}</label>
          <div class="card-input" id="creditCardNumber"></div>
          <div class="input-group">
            <div class="card-input half-width" id="expireDate"></div>
            <div class="card-input half-width" id="cvv"></div>
          </div>
          <label class="label" :class="$i18n.locale === 'ar' ? 'label-right' : ''">{{$t('card_details_card_holder_name')}}</label>
          <div class="card-input" id="cardHolderName"></div>
          <SubmitButton :label="$t('card_details_page_button')" :isLoading="cc_button_loading" @click="payWithCreditCard"/>
        </div>
    </div>
    </div>
    <PricingPopup  v-if="showPricingPopup" @togglePricingModal="togglePricingModal"/>
  </div>
</template>
<script>
import {client, dataCollector, fastlane, hostedFields, paypalCheckout} from 'braintree-web';
import SubscriptionService from '../services/subscription.service';
import paypal from 'paypal-checkout';
import AuthService from '../services/auth.service';
import {mapGetters} from "vuex";
import {DESCRIPTION_TRANSLATION_KEY, getSubscribedProducts, PRODUCT_LABELS, PRODUCT_TYPES} from "../utils/constant";
import {validateCoupon} from "../services/subscriptions.v2.services";
import SubmitButton from '../components/SubmitButton.vue';
import PricingCard from '../components/PricingCard.vue';
import PricingPopup from '../components/PricingPopup.vue';
import deviceMixin from '../mixins/deviceMixin';
import GooglePay from '../components/GooglePay.vue';
import AppLoader from '../components/AppLoader.vue';
import BadgeNotification from '../components/BadgeNotification.vue';
import DiscountCouponBanner from '../components/DiscountCouponBanner.vue';
import { Events } from '../../src/utils/analytics'
import TextInputField from '../components/TextInputField.vue';

export default {
  mixins: [deviceMixin],
  components: {
    SubmitButton,
    PricingCard,
    PricingPopup,
    GooglePay,
    AppLoader,
    BadgeNotification,
    TextInputField,
    DiscountCouponBanner
  },
  data() {
    return {
      cardNumber: "",
      expiryDate: "",
      hideCouponBanner: true,
      promoLabel: '',
      cvc: "",
      cardName: '',
      disablePromoBox: false,
      loading: false,
      showPricingPopup: false,
      braintreeFullyLoaded: false,
      couponHasError: false,
      couponErrorMessage: '',
      titles: [
        {name: this.$t('plan_select_page_title'), status: true, step: 1},
        {name: this.$t('payment_select_page_title'), status: false, step: 2},
        {name: this.$t('card_details_page_title'), status: false, step: 3},
      ],
      cc_button_loading: false,
      active_step: 1,
      featureDesktopTitle: true,
      promoTitles: DESCRIPTION_TRANSLATION_KEY,
      coupon_error: false,
      has_coupon: false,
      couponProduct: '',
      showCouponError: false,
      discountPromoApplied: false,
      accessPromoApplied: false,
      discounts: 0.00,
      clientToken: null,
      isApplePay: false,
      couponDurationCode: this.$store.getters.getCouponDuration || '',
      coupon: this.$store.getters.getCoupon || '',
    };
  },

  computed: {
    ...mapGetters({
      possiblePlans: 'getAllPlans',
      allPlans: 'getUserPlans',
      selectedTypePlans: 'getSelectedPlans',
      currentPlanType: 'getCurrentPlanType',
      currentSelectedPlan: 'getCurrentSelectedPlan',
      currentSelectedPlans: 'getCurrentSelectedPlans',
      showCurrentPlanSelected: 'getShowCurrentPlanSelected'
    }),
    hasDiscountDetails() {
      return this.$store.getters.gethasDiscountDetails;
    },
    formattedPrice() {
      return `${this.totalPrice}${this.currentSelectedPlan.currencySymbol}/${this.$t(this.currentPlanType)}`;
    },
    isChangePlan() {
      return this.$route.path === '/changePlan'
    },
    subscriptionTypes() {
      return this.$store.getters.getSubscriptionsList.map((({subscriptionType}) => subscriptionType));
    },
    hasSubscription() {
      return this.$store.getters.getSubscriptionIsRenew
    },
    hasUtmData() {
      const persistedState = JSON.parse(sessionStorage.getItem('kidjo_accounts'));
      const utmData = persistedState?.analytics?.utmData;
      return utmData;
    },

    activePlan: function () {
      const appendPlus = this.currentSelectedPlans.length > 1;
      const plan = this.currentSelectedPlans.reduce((accumulator, product, index) => {
        const separator = (appendPlus && index < this.currentSelectedPlans.length - 1) ? ' +' : '';
        return accumulator + `${PRODUCT_LABELS[product.product]}${separator} `;
      }, '');
      return `${plan}`
    },
    getCoupon: function () {
      return this.coupon || this.$store.getters.getCoupon;
    },
    userUsedCoupon: function () {
      return (this.$store.getters.getCouponDuration || this.$store.getters.getCoupon);
    },
    getCouponLabel: function () {
      if (!localStorage.getItem('discountDetails') && this.$store.getters.getCoupon) {
        return  this.hasUserAppliedCoupon ? this.$t('payment_select_page_promo_code') + ': ' + this.$store.getters.getCoupon : this.$store.getters.getCoupon;
      }
      if (!localStorage.getItem('discountDetails')) return;
      const coupon = this.couponDurationCode || this.$store.getters.getCouponDuration;
      const { discountPrice } = JSON.parse(localStorage.getItem('discountDetails'));

      if (!coupon) return '';

      // Match both formats: P6M or PM6
      let match = coupon.match(/^P(\d+)([MDY])$/i);      // e.g., P6M
      if (!match) {
        match = coupon.match(/^P([MDY])(\d+)$/i);        // e.g., PM6
        if (match) {
          // Swap to standard order: number first, unit second
          match = [match[0], match[2], match[1]];
        }
      }

      if (!match) return ''; // invalid format

      const number = parseInt(match[1], 10);
      const unit = match[2].toUpperCase();

        if (discountPrice) {
        const currentPlan = this.possiblePlans.find(obj=> obj.durationCode === this.currentSelectedPlan.durationCode);
        const discountedPrice = currentPlan.price - discountPrice + currentPlan.currencySymbol;
        const fullPrice = currentPlan.price + currentPlan.currencySymbol;
        if (unit === 'M') {
            return this.$t('promo_discount_duration_label', { discount_price: discountedPrice,  duration: number, full_price: fullPrice });
          } else if (unit === 'Y') {
            return this.$t('label_coupon_yearly_discount_text', { discount_price: discountedPrice, full_price: fullPrice });
          }
          else {
            return '';
          }
        }
      
        if (unit === 'D') {
          return this.$t('registration_coupons_positive_validation_day', { xx: number });
        } else if (unit === 'M') {
          return this.$t('registration_coupons_positive_validation', { xx: number });
        }

      return '';
    },
    getCouponDuration: function () {
      const duration_period = {
        day: this.$t('label_day'),
        days: this.$t('label_days'),
        month: this.$t('month'),
        months: this.$t('label_months'),
      };

      const value = this.couponDurationCode || this.$store.getters.getCouponDuration;

      const duration = value.replace(/\D/g, '');

      let suffix = 'month';

      if (value.includes('D')) {
        suffix = 'day';
      }

      if (duration > 1) {
        suffix += 's';
      }

      return {duration,"durationPeriods":duration_period[suffix],"durationPeriod":duration_period[suffix.slice(0,-1)]};
    },

    getCouponProduct: function () {
      if (this.subscriptionFor === "tv") {
        return "- Kidjo TV";
      } else if (this.subscriptionFor === "books") {
        return "- Kidjo Stories";
      } else if (this.subscriptionFor === "games") {
        return "- Kidjo Games";
      } else {
        return "- Kidjo TV + Kidjo Stories + Kidjo Games";
      }
    },
    totalPrice: function () {
      const {currentSelectedPlans, isChangePlan} = this;
      let total = 0.00;
      if (isChangePlan) {
        currentSelectedPlans.forEach((product, index) => {
          if (index === 0) {
            total = total + product.price
          } else if (index === 1) {
            total = product.price + product.addOns[0].price;
          } else if (index === 2) {
            total = product.price + product.addOns[1].price;
          }
        });
        total = total - this.discountPrice;
        return total.toFixed(2);
      } else {
        total = this.totalPriceWithoutModifyingPlan - this.discountPrice;
        return total.toFixed(2);
      }
    },
    totalPriceWithoutModifyingPlan: function () {
      const {currentSelectedPlans, subscriptionTypes} = this;
      let total = 0.00;
      const subscribedProducts = getSubscribedProducts(subscriptionTypes)
      currentSelectedPlans.forEach((product, index) => {
        if (index === 0) {
          total = total + (subscribedProducts.length === 0 ? product.price :
              subscribedProducts.length === 1 ? product.addOns[0].price
                  : (product.addOns[1].price - product.addOns[0].price))
        } else if (index === 1) {
          total = (subscribedProducts.length === 0 ?
              (product.price + product.addOns[0].price) :
              product.addOns[1].price);
        } else if (index === 2) {
          total = product.price + product.addOns[1].price;
        }
      });
      return total;
    }
    ,

    originalPrice: function () {
      const {currentSelectedPlans,isChangePlan} = this
      let total = 0.00;
      if(!isChangePlan){
        currentSelectedPlans.forEach((product, index) => {
          if (index === 0) {
            total = total + product.price
          } else if (index === 1) {
            total = product.price + product.addOns[0].price;
          } else if (index === 2) {
            total = product.price + product.addOns[1].price;
          }
        });
      }else {
        currentSelectedPlans.forEach((product) => {
          total = total + product.price;
        });
      }
      return total.toFixed(2);
    },
    discountPrice: function () {
      if (localStorage.getItem('discountDetails') != null) {
        const {discountPrice, isBundleDiscount, planType} = JSON.parse(localStorage.getItem('discountDetails'));
        if (isBundleDiscount && this.currentSelectedPlans.length < 2) {
          return 0.00;
        }
        if (this.currentPlanType !== planType) {
          return 0.00
        }

        return !discountPrice ? 0.00 : discountPrice;
      }
      return 0.00
    },
    formattedDiscountPrice: function () {
      if (localStorage.getItem('discountDetails') != null) {
        const {discountPrice} = JSON.parse(localStorage.getItem("discountDetails"));
        return `${discountPrice}${this.currentSelectedPlan.currencySymbol}`
      }
      return ''
    },
    hasUserAppliedCoupon: function () {
      return this.$store.getters.getDiscountPromoApplied;
    },
    hasUserCouponAndDuration: function () {
      return this.getStoreCoupon && this.$store.getters.getCouponDuration;
    },
    applyCoupon: function () {
      return this.getCoupon;
    },
    getStoreCoupon: function () {
      return this.$store.getters.getCoupon;
    }
  },

  watch: {
    currentSelectedPlan(newVal, oldVal) {
      const discountDetails = localStorage.getItem("discountDetails");
      if (!discountDetails) {
        return;
      }
      const { planType } = JSON.parse( discountDetails);
      if (newVal.nameKey === 'monthly_plan' && planType === 'annual_plan') {
        this.resetCouponDetails(this.$t('label_coupon_valid_yearly_only'), true);
      } else if (newVal.nameKey === 'annual_plan' && planType === 'monthly_plan') {
        this.resetCouponDetails(this.$t('label_coupon_valid_monthly_only'), true);
      }
      this.removeCoupon();
    }
  },

  methods: {
    handleError(error) {
      if (error === 'yearly_only') {
        this.couponHasError = true;
        this.couponErrorMessage = this.$t('label_coupon_valid_yearly_only'); 
      } else if (error === 'monthly_only') {
        this.couponHasError = true;
         this.couponErrorMessage =  this.$t('label_coupon_valid_monthly_only');
      } else {
        this.couponHasError = true;
        this.couponErrorMessage =  this.$t('promo_invalid_code_message');
      }
    },
    checkFields: function () {
      var couponHasError = false;

      if (this.coupon === '') {
        this.couponHasError = true;
        this.couponErrorMessage = this.$t('error_message_coupon_required');
      }

      return couponHasError;
    },
    resetCouponErrorMessage() {
      this.couponHasError = false;
      this.disablePromoBox = false;
      this.couponErrorMessage = '';
    },
    resetCouponDetails(message = '', hasError = false) {
      this.couponHasError = hasError;
      this.disablePromoBox = false;
      this.couponErrorMessage = message;
      this.has_coupon = false;
      this.coupon = '';
      this.$store.commit('setCoupon', '');
      this.$store.commit('setDuration', '');
    },
    closeDiscountCouponBanner() {
      this.hideCouponBanner = true;
      this.$store.commit('setDiscountPromoApplied', false);
      this.$store.commit('setCoupon', '');
      this.$store.commit('setDuration', '');
      this.resetCouponErrorMessage();

    },
    checkApplePaySupport: function () {
      this.isApplePay = this.isAppleDevice(); // Just call the method that updates the visibility state
    },
    formatCardNumber() {
      this.cardNumber = this.cardNumber
        .replace(/\D/g, "") // Remove non-numeric characters
        .replace(/(\d{4})/g, "$1 ") // Add space after every 4 digits
        .trim();
    },
    formatExpiry() {
      this.expiryDate = this.expiryDate
        .replace(/\D/g, "") // Remove non-numeric characters
        .replace(/^(\d{2})(\d{0,2})/, "$1 / $2") // Format MM/YY
        .trim();
    },
    removeCouponFromStorage: function () {
      this.removeCoupon();
    },
    togglePricingModal() {
      this.showPricingPopup = !this.showPricingPopup;
    },
    fixDisplayLabel(label) {
      return this.$t(label, {step: 2});
    },
    onPlanSelect: function (event, plan) {  
      if (event) {
        this.$store.commit('setCurrentSelectedPlans', plan);
      } else {
        this.$store.commit('removeFromSelectedPlan', plan);
      }
      if (this.coupon || this.$store.getters.getCoupon) {
        this.setDiscountPromo(localStorage.getItem("discountDetails") !== null);
        if (this.discountPromoApplied) {
          const {isBundleDiscount, planType} = JSON.parse(localStorage.getItem('discountDetails'));
          if (isBundleDiscount && planType === this.currentPlanType && this.currentSelectedPlans.length < 2) {
            this.$parent.showFlashMessage(this.$t('only_two_products'));
            this.setDiscountPromo(false);
          }
        }
      }

    },
    setDiscountPromo: function (value) {
      this.discountPromoApplied = value
    },

    setAccessPromo:function(value){
      this.accessPromoApplied=value
    },

    setHasCoupon: function (value) {
      this.has_coupon = value
    },
    checkCoupon: function () {
      if (this.coupon !== '') {
        this.disablePromoBox = true;
        validateCoupon(this.coupon || this.getStoreCoupon)
            .then((response) => {
              if (response.status === 201) {
                const currentPlan = this.possiblePlans.find(obj=> obj.durationCode === this.currentSelectedPlan.durationCode);
                const {couponType} = response.data
                if (couponType === "FREE_ACCESS_COUPON" || couponType === "UNIQUE_ACCESS_COUPON") {
                  this.removeCouponFromStorage();
                  return this.$router.push('/products');
                }
                if (!response.data?.discountDetails) {
                  const couponCode = response.data.couponDurationCode || '';
                  const hasMonth = couponCode.includes('M');
                  const hasYear = couponCode.includes('Y');

                  const plan = this.currentSelectedPlan.nameKey;
                  const isMonthlyPlan = plan === 'monthly_plan';
                  const isAnnualPlan = plan === 'annual_plan';

                  if (isMonthlyPlan && hasYear) {
                    this.resetCoupon(this.$t('label_coupon_valid_yearly_only'));
                    return;
                  }

                  if (isAnnualPlan && hasMonth) {
                    this.resetCoupon(this.$t('label_coupon_valid_monthly_only'));
                    return;
                  }
                }
                if (this.currentSelectedPlan.nameKey === 'monthly_plan' && response.data.discountDetails && response.data.discountDetails.planType === 'annual_plan') {
                  this.resetCouponDetails(this.$t('label_coupon_valid_yearly_only'), true);
                  return;
                } else if (this.currentSelectedPlan.nameKey === 'annual_plan' && response.data.discountDetails && response.data.discountDetails.planType === 'monthly_plan') {
                  this.resetCouponDetails(this.$t('label_coupon_valid_monthly_only'), true);
                  return;
                }
                this.saveCoupon(response.data);
                this.hideCouponBanner = false;
              
                if(couponType === "DISCOUNT_COUPON" || couponType === "UNIQUE_DISCOUNT_COUPON") {
                  this.discountPromoApplied = true;
                }
                if (couponType === "STANDARD_COUPON" || couponType === "UNIQUE_COUPON") {
                  this.accessPromoApplied = true;
                }
                this.has_coupon = true;
                if (response?.data?.discountDetails) {
                  localStorage.setItem('discountDetails', JSON.stringify(response.data.discountDetails));
                  this.$store.commit('setHasDiscountDetails', true);
                }
              }
            }).catch((error) => {
              this.disablePromoBox = false;
              if (error.code === 'ERR_BAD_REQUEST' || error.code === 3) {
                this.resetCouponDetails(this.$t('promo_invalid_code_message'), true);
              } else if (error.code === 7 || error.code === 'ERR_BAD_REQUEST') {
                this.resetCouponDetails(this.$t('promo_invalid_code_message'), true);
              }
            this.removeCoupon();
        });
      } else {
        this.couponHasError = true;
        this.disablePromoBox = false;
        this.couponErrorMessage = this.$t('error_message_coupon_required');
        this.resetCouponDetails(this.$t('error_message_coupon_required'), true);

      }
    },

    saveCoupon: function (data) {
      this.coupon =  data.couponSerialNumber || this.getStoreCoupon;
      this.couponDurationCode = data.couponDurationCode;
      this.$store.commit('setCoupon', this.coupon);
      this.$store.commit('setDuration', data.couponDurationCode);

      window.dispatchEvent(new Event("storageLocalUpdate"));

      this.couponProduct = data.couponProduct;
    },
    resetCoupon (messageKey) {
      this.couponHasError = true;
      this.disablePromoBox = false;
      this.couponErrorMessage = messageKey;
      localStorage.removeItem('couponProduct');
      this.$store.commit('setDuration', '');
      this.$store.commit('setCoupon', '');
      this.$store.commit('setDiscountPromoApplied', false);
    },
    removeCouponFromStorage: function () {
      localStorage.removeItem('discountDetails');
      this.$store.commit('setHasDiscountDetails', false);
      this.$store.commit('setDiscountPromoApplied', false);
      this.$store.commit('setCoupon', '');
      this.$store.commit('setDuration', '');
    },

    removeCoupon: function () {
      this.couponProduct = '';
      this.has_coupon = false;
    },

    showPlanSelectForm: function () {
      this.active_step = 1;
      this.changeActiveTitle();
    },

    showPaymentOptions: function () {
      // this can be on mounted
      if (this.currentSelectedPlans.length > 0) {
        this.active_step = 2;
        this.changeActiveTitle();
        if (!this.paypal_instaled) {
          this.loading = true;
        }
      } else {
        this.$parent.showFlashMessage(this.$t('select_plan_please_select_plan'));
      }
      if(!this.discountPromoApplied && !this.accessPromoApplied){
        this.removeCoupon()
      }

    },

    showCardForm: function () {
      this.active_step = 3;
      this.changeActiveTitle();
      this.scrollDown();

      if (!this.braintree_instaled) {
        this.$parent.loading = true;
      }
    },

    changeActiveTitle: function () {
      for (var i = 0; i < this.titles.length; i++) {
        this.titles[i].status = false;

        if (this.titles[i].step === this.active_step) {
          this.titles[i].status = true;
        }
      }
    },

    onPlanTypeSelect: function (nameKey) {
      this.$store.commit('resetCurrentSelectedPlans');
      this.$store.commit('setCurrentPlanType', nameKey);
      this.$store.commit('setSelectedPlans', this.allPlans.userPlan.find(type => type.nameKey === nameKey).plans);
      this.$store.commit('setCurrentSelectedPlans', this.allPlans.userPlan.find(type => type.nameKey === nameKey).plans[0]);
      if (this.coupon || this.$store.getters.getCoupon) {
        const discountDetails = localStorage.getItem('discountDetails');
        if (this.discountPromoApplied) {
          const {isBundleDiscount,planType} = JSON.parse(discountDetails);
          // Bundle Discount so more than one product will be selected by default
          if (planType !== nameKey) {
            this.$parent.showFlashMessage(this.$t('monthly_only'));
          }
          if(isBundleDiscount){
            this.$store.commit('setCurrentSelectedPlans', this.allPlans.userPlan.find(type => type.nameKey === nameKey).plans[1]);
          }
        }
        this.setDiscountPromo(discountDetails!==null);
      }
    },
    payWithCreditCard: function () {
      this.cc_button_loading = true
      var self = this;
      this.hostedFieldsInstance.tokenize().then(payload => {
        self.braintreeNonce = payload.nonce;
        self.selected_device_data = self.device_data_braintree;
        self.sendNonce(payload.nonce, payload.details.cardholderName, '');
      }).catch(error => {
        self.handleBraintreeErrors(error.code);
      });
    },

    buildProduct: function () {
      const {currentSelectedPlans} = this
      return 'kidjo_' + currentSelectedPlans
          .map(product => product.product)
          .join('_')
    },

    buildProductForSubscription: function () {
      const {subscriptionTypes, currentSelectedPlans} = this
      let product = 'kidjo_'
      if (subscriptionTypes.length > 0 && !this.isChangePlan) {
        product = product + this.subscriptionTypes.map(product => {
          return PRODUCT_TYPES[product]
        }).join('_');
        product = `${product}_` + currentSelectedPlans
            .map(product => product.product)
            .join('_')
        return product;
      } else {
        return this.buildProduct();
      }
    },
    hasNoSubscriptions: function () {
      return (!Array.isArray(this.$store.getters.getUserSubscriptions) || this.$store.getters.getUserSubscriptions.length === 0 || this.$store.getters.getUserSubscriptions.every(({ nextBillingDate }) => new Date(nextBillingDate) < Date.now()));
    },
    sendNonce: function (nonce, name, deviceData) {
      this.$parent.loading = true;
      const {currentSelectedPlan, currentSelectedPlans, subscriptionTypes} = this;
      let mainProduct = this.buildProductForSubscription();
      const currentPlan = this.possiblePlans.find(obj=> obj.durationCode === this.currentSelectedPlan.durationCode);
      const plan = {
        planId: currentPlan.iap,
        product: currentPlan.product,
        addOns: currentPlan.addOns[0]
      };
      const request = {
        paymentNonce: nonce,
        plans: plan,
        isBundle: (this.subscriptions !== null || this.currentSelectedPlans.length > 1),
        coupon: this.applyCoupon === null ? "" : this.applyCoupon,
        deviceData: deviceData ? deviceData : this.selected_device_data,
        billingName: name
      };
      if (this.hasUtmData && Object.keys(this.hasUtmData).length > 0) {
        request.utm = this.hasUtmData;
      }
      this.$store.dispatch('subscribe', request).then((response) => {
        var subscribeId = response.data.subscriptionId;
        if (response.status === 200) {
          if (typeof fbq === 'function' && this.hasNoSubscriptions()) {
            fbq('track', 'Purchase', {email_id: this.$store.getters.getCurrentAccountEmail});
          }
          if (typeof gtag === 'function' && this.hasNoSubscriptions()) {
            gtag('event', 'conversion', {
                'send_to': process.env.VUE_APP_GOOGLE_ADS_KEY || 'AW-17553248740/DIZTCNryv5wbEOSjhbJB',
                'transaction_id': response.data.subscriptionId,
                'email_id': this.$store.getters.getCurrentAccountEmail
            });
          }
          this.removeCouponFromStorage();
          this.$store.dispatch('checkUserSubscriptions').then((response) => {
            this.$store.dispatch('updateSubscriptionPayload',  {
                id: subscribeId,
                coupon: request.coupon,
                couponDuration: '',
                expiryDate: '',
                plan: request.plans.planId,
                product: request.plans.product,
                paymentMethod: response.data.subscriptions[0].paymentMethod
              }).then((response) => {
                this.$store.dispatch('updatePaymentsPayload', '').then(() => {
                  this.$store.dispatch('postAnalytics', Events.PAYMENTDONE);
                });
              });
          });
          this.$parent.loading = false;

          // Check if the we have to go to tv app folder
          if (localStorage.getItem('tvAppFolderId') && (this.subscriptionFor === 'tv' || this.subscriptionFor === 'combo')) {
            var id = localStorage.getItem('tvAppFolderId');

            // remove the id from local Storage
            localStorage.removeItem('tvAppFolderId');

            // go to tv app folder
            AuthService.generateRedirectKey()
                .then((response) => {
                  if (response.status === 200) {
                    // this.$store.dispatch('postAnalytics', Events.EXIT);
                    window.location.replace(process.env.VUE_APP_WEB_APP_URL + 'folder/' + id + '?key=' + response.data.redirectKey);
                  }
                }).catch((error) => {
              this.$parent.showFlashMessage(this.$t('error_generic'))
            });
          } else {
            if (this.checkStorageForSwisscomeCampaign()) {
              localStorage.removeItem('swissComeCampaign');
            }
          }
          this.cc_button_loading = false;
          if(localStorage.getItem('app')) {
            var appName = localStorage.getItem('app')
            localStorage.removeItem('app') 
            AuthService.generateRedirectKey()
            .then((response) => {
              if (response.status === 200) {
                this.$parent.loading = false;
                // this.$store.dispatch('postAnalytics', Events.EXIT);
                window.location.replace(this.routeBackToWebApp(appName) + '?key='+response.data.redirectKey);
              }
            }).catch((error) => {
              this.$parent.loading = false;
            });
        } else {
          this.$router.push({name: 'profile'});
        }

        }
      }).catch((error) => {
        this.cc_button_loading = false;
        this.$parent.loading = false;
        if (error.response.status === 400) {
          this.$parent.showFlashMessage(this.$t('payment_feedback_not_valid'));
        } else {
          this.$parent.showFlashMessage(this.$t('error_generic'))
        }
      });

    },
    routeBackToWebApp: function(appName) {
				const actionMap = {
					['games']: process.env.VUE_APP_GAMES_APP_URL,
					['stories']: process.env.VUE_APP_STORIES_APP_URL,
					['tv']: process.env.VUE_APP_WEB_APP_URL,
					['kidjo-world']: process.env.VUE_APP_WEB_APP_LINK
				};
				return actionMap[appName];		
			},
    handleBraintreeErrors: function (code) {
      if (code === "HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR") {
        this.$parent.showFlashMessage(this.$t('braintree_error_message_network_error'));
      }
      if (code === "HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE") {
        this.$parent.showFlashMessage(this.$t('braintree_error_message_duplicated_payment_error'));
      }

      if (code === "HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED") {
        this.$parent.showFlashMessage(this.$t('braintree_error_message_cvv_verification_failed'));
      }

      if (code === "HOSTED_FIELDS_FAILED_TOKENIZATION") {
        this.$parent.showFlashMessage(this.$t('braintree_error_message_faled_tokenization'));
      }

      if (code === "HOSTED_FIELDS_FIELDS_EMPTY") {
        this.$parent.showFlashMessage(this.$t('braintree_error_message_empty_fields'));
      }

      if (code === "HOSTED_FIELDS_FIELDS_INVALID") {
        this.$parent.showFlashMessage(this.$t('braintree_error_message_invalid_fields'));
      }
      this.cc_button_loading = false;
    },

    generateClientToken: function () {
      SubscriptionService.generateToken()
          .then((response) => {
            if (response.status === 200) {
              this.client_token = response.data;
              this.clientToken = response.data;
              this.initPaypal();
              this.initBraintree();
            }
          }).catch((error) => {
        if (error.response.status === 400) {
          if (error.response.data.code === 1) {
            this.$parent.showFlashMessage(this.$t('braintree_error_message_problem_generate_client_token'));
          }
        }
      });
    },

    initBraintree: function () {
      var self = this;
      // by braintree sdk client method
      client.create({
        authorization: self.client_token
      }, function (err, clientInstance) {
        if (err) {
          console.error(err);
          return;
        }
        dataCollector.create({
          client: clientInstance,
          kount: true
        }, function (err, dataCollectorInstance) {
          if (err) {
            return;
          }
          self.device_data_braintree = dataCollectorInstance.deviceData;
        });
        hostedFields.create({
          client: clientInstance,
          styles: {
            'color': '#a7948d',
            'font-family': 'Nunito-Regular',
            'font-weight': 600,
            'font-size': '18px',
            'opacity': 1,
            'font-variant-numeric': 'tabular-nums'
          },
          fields: {
            cardholderName: {
              selector: '#cardHolderName',
              placeholder: ''
            },
            number: {
              selector: '#creditCardNumber',
              placeholder: '0000 0000 0000 0000'
            },
            cvv: {
              selector: '#cvv',
              placeholder: 'CVV'
            },
            expirationDate: {
              selector: '#expireDate',
              placeholder: 'MM / YY'
            }
          }
        }, function (err, hostedFieldsInstance) {
          self.hostedFieldsInstance = hostedFieldsInstance;
          self.braintree_instaled = true;
          self.$parent.loading = false;
          var cardNumberField = hostedFieldsInstance.fields['number'];

            // Add an input listener to the card number field
            cardNumberField.on('input', function (event) {
              var value = event.target.value.replace(/\s+/g, ''); // Remove spaces
              if (value.length > 16) {
                // Limit input to 20 digits
                value = value.slice(0, 16);
              }

              // Reformat the value with spaces after every 4 digits
              event.target.value = value.replace(/(.{4})(?=.{4})/g, '$1 ');

              // Update the hosted field with the new value
              cardNumberField.setValue(event.target.value);
            });
        });
        
      });
    },

    initPaypal: function () {
      var self = this;
      client.create({
        authorization: self.client_token
      }, function (clientErr, clientInstance) {
        if (clientErr) {
          console.error('Error creating client:', clientErr);
          return;
        }

        paypalCheckout.create({
          client: clientInstance
        }, function (paypalCheckoutErr, paypalCheckoutInstance) {
          dataCollector.create({
            client: clientInstance,
            paypal: true
          }, function (err, dataCollectorInstance) {
            if (err) {
              return;
            }
            var myDeviceData = dataCollectorInstance.deviceData;
            self.device_data_paypal = myDeviceData;
          });
          if (paypalCheckoutErr) {
            console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
            return;
          }
          paypal.Button.render({
            env: process.env.VUE_APP_BRAINTREE_ENV, // 'production' or 'sandbox'
            style: {
              label: 'paypal',
              size: 'responsive',
              shape: 'rect',
              color: 'white',
              tagline: false,
              height: 40
            },
            payment: function () {
              return paypalCheckoutInstance.createPayment({
                flow: 'vault',
                currency: 'CHF'
              });
            },
            onAuthorize: function (data, actions) {
              return paypalCheckoutInstance.tokenizePayment(data)
                  .then(function (payload) {
                    self.selected_device_data = self.device_data_paypal;
                    self.paypalNonce = payload.nonce;
                    self.$parent.loading = true;
                    self.sendNonce(payload.nonce, '', '')
                  });
            },
            onCancel: function (data) {
              console.log('checkout.js payment cancelled', JSON.stringify(data, 0, 2));
            },
            onError: function (err) {
              this.$parent.showFlashMessage(this.$t('error_generic'));
            }
          }, '#paypalButton').then(function () {
            self.paypal_instaled = true;
            self.$parent.loading = false;
            self.braintreeFullyLoaded = true;
          });

        });

      });
    },

    scrollDown: function () {
      if (window.innerWidth <= 768) {
        setTimeout(function () {
          window.scrollTo(0, 120);
        }, 1000)
      }
    },

    checkStorageForCoupon: function () {
      const coupon = this.$store.getters.getCoupon;
      return coupon != null;
    },

    checkStorageForSwisscomeCampaign: function () {
      var coupon = localStorage.getItem('swissComeCampaign');

      if (coupon == null) {
        return false;
      }

      return true;
    },
  },

  mounted: function () {

    const error = this.$route.query.error;
    if (error) {
      this.handleError(error);
    }

    // Call the function once when the component is mounted
    this.checkApplePaySupport();

    // Add resize event listener
    window.addEventListener("resize", this.checkApplePaySupport);
    window.addEventListener("storageLocalUpdate", () => {
      this.$forceUpdate(); // forces computed to re-run
    });

    if (localStorage.getItem('storeId') !== 'switch' && (this.subscriptionTypes.includes('kidjo_tv_books_games')
        && this.$route.path !== '/changePlan'
        && this.$route.path !== '/resubscribe'
        || (this.subscriptionTypes.includes('kidjo_tv')
            && this.subscriptionTypes.includes('kidjo_books')
            && this.subscriptionTypes.includes('kidjo_games')))) {
      return this.$router.push({name: 'profile'}).catch(() => {
      });
    } else if (this.$parent.tvPlatform) {
      localStorage.removeItem('storeId');
      this.$store.dispatch('logout');
      this.$parent.showLoginQR = true;
      this.$parent.showFlashMessage(this.$t('tv_login_header_subscription_expired'));
      return this.$router.push({name: 'login'}).catch(() => {
      });
    } else if (localStorage.getItem('storeId') === 'switch') {
      localStorage.removeItem('storeId')
    }

    /*
      - Check if coupon is saved in storage
      - If we have coupon in storage, save the coupon in local varibles and remove it from storage
    */
    if (this.checkStorageForCoupon()) {
      this.coupon = this.getStoreCoupon;
      this.couponDurationCode = this.$store.getters.getCouponDuration;
      this.couponProduct = localStorage.getItem('couponProduct');
      const discountDetails = localStorage.getItem('discountDetails');
      this.setDiscountPromo(discountDetails !== null);
      this.setAccessPromo(discountDetails === null);
      this.has_coupon = true;
    }

    this.$store.commit('resetCurrentSelectedPlans');
    // this.$store.commit('removeCurrentSelectedPlan');
    this.$store.dispatch('getUserEligiblePlans',
        {
          showAll: this.$route.path === '/changePlan',
          currentSubscription: this.subscriptionTypes,
          countryCode: localStorage.getItem('cc')
        });

    // Show plan title based on device width
    if (window.innerWidth <= 768) {
      this.featureDesktopTitle = false;
    }

    this.generateClientToken();
    this.scrollDown();

    // Swisscome free campaign
    if (this.checkStorageForSwisscomeCampaign()) {
      this.coupon = "YAJKM0";
      this.couponDurationCode = "P2M";
      this.$store.commit('setCoupon', this.coupon);
      this.$store.commit('setDuration', "P2M");
    }

    // Change Background color and color of footer and header
    if (this.$parent.appStyle === 'profile') {
      this.$parent.changeAppStyle('subscribe');
    }
  },

  beforeDestroy: function () {
    window.removeEventListener("resize", this.checkApplePaySupport);
    this.$store.commit('setDuration', '');
    this.$store.commit('setCoupon', '');
    localStorage.removeItem('discountDetails');
    this.$store.commit('setHasDiscountDetails', false);
    this.$store.commit('setDiscountPromoApplied', false);
  },
}
</script>
<style lang="sass">
.set-margin-bottom
  margin-bottom: 0px
#paypalButton
  width: 100%
.zoid-outlet 
  width: calc( 100% - 2px ) !important

.hide-over-button
  opacity: 0
  pointer-events: auto
  position: absolute
  z-index: 9999
  width: 90%
  height: 90%
  display: flex

.coupon-code-container
  display: flex
  flex-direction: row

.coupon-code-box
  display: flex
  flex-direction: column

    
.coupon-btn
  max-width: 30%
  margin-left: 10px

.subscription-card-graphic
  margin-top: -80px

  svg
    width: 100px
    height: 100px

.subscription-card-details
  margin-top: 25px
  display: flex
  flex: 1
  flex-direction: column
  justify-content: space-between
  align-items: center

.text-wrapper
  margin-bottom: 12px

.content-23
  margin-bottom: 0px

.disabled
  opacity: 0.5

.reg-sub-title
  font-size: 20px
  font-family: "Nunito-Regular"
  color: #020076

.reg-sub-heading
  font-size: 16px
  font-family: "Nunito-Regular"
  color: #020076
  float: Left
  text-align: left
  padding-block: 5px

.paypal-button
  display: flex
  align-items: center
  justify-content: center
  background: #EDEDED
  border: none
  cursor: pointer
  color: #003087 /* PayPal blue */
  height: 40px
  position: relative

.divider
  display: flex
  align-items: center
  text-align: center

.divider span
  flex: 1
  height: 1px
  background: #020076
  margin: 0 5px

.divider p
  font-size: 16px
  color: #020076
  font-family: "Nunito-Regular"

.label
  font-size: 16px
  font-family: "Nunito-Regular"
  color: #020076
  text-align: left
.label-right
  text-align: right

.input-group
  display: flex
  gap: 10px

.half-width
  width: 50%

.full-width
  width: 100%

.card-input
  display: block
  height: 40px
  width: 100%
  border: 1px solid #ccc
  border-radius: 10px
  padding: 10px 30px 10px 15px
  box-sizing: border-box

.loader-container
  width: 100%;
  min-height: 60dvh;
  padding: 16px;
  position: relative;
  background-color: #fff;
.loader
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 20px
    height: 20px
    border: 2px solid #020076
    border-top: 2px solid transparent
    border-radius: 50%
    animation: spin 0.8s linear infinite
</style>
